"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("./types");

function normalizeValue(value, index, min, max, step, allowOverlap, values) {
  var BIG_NUM = 10e10;
  value = Math.round(value * BIG_NUM) / BIG_NUM;

  if (!allowOverlap) {
    var prev = values[index - 1];
    var next = values[index + 1];
    if (prev && prev > value) return prev;
    if (next && next < value) return next;
  }

  if (value > max) return max;
  if (value < min) return min;
  var remainder = Math.round(value * BIG_NUM) % Math.round(step * BIG_NUM);
  var closestBigNum = Math.round(value * BIG_NUM - remainder);
  var rounded = remainder === 0 ? value : closestBigNum / BIG_NUM;
  var res = Math.abs(remainder / BIG_NUM) < step / 2 ? rounded : rounded + step * Math.sign(value);
  var afterDot = step.toString().split('.')[1];
  return afterDot ? parseFloat(res.toFixed(afterDot.length)) : res;
}

exports.normalizeValue = normalizeValue;

function relativeValue(value, min, max) {
  return (value - min) / (max - min);
}

exports.relativeValue = relativeValue;

function isVertical(direction) {
  return direction === types_1.Direction.Up || direction === types_1.Direction.Down;
}

exports.isVertical = isVertical;

function checkBoundaries(value, min, max) {
  if (min >= max) {
    throw new RangeError("min (" + min + ") is equal/bigger than max (" + max + ")");
  }

  if (value < min) {
    throw new RangeError("value (" + value + ") is smaller than min (" + min + ")");
  }

  if (value > max) {
    throw new RangeError("value (" + value + ") is bigger than max (" + max + ")");
  }
}

exports.checkBoundaries = checkBoundaries;

function checkInitialOverlap(values) {
  if (values.length < 2) return;

  if (!values.slice(1).every(function (item, i) {
    return values[i] <= item;
  })) {
    throw new RangeError("values={[" + values + "]} needs to be sorted when allowOverlap={false}");
  }
}

exports.checkInitialOverlap = checkInitialOverlap;

function getMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    top: parseInt(style['margin-top'], 10),
    bottom: parseInt(style['margin-bottom'], 10),
    left: parseInt(style['margin-left'], 10),
    right: parseInt(style['margin-right'], 10)
  };
}

exports.getMargin = getMargin;

function getPadding(element) {
  var style = window.getComputedStyle(element);
  return {
    top: parseInt(style['padding-top'], 10),
    bottom: parseInt(style['padding-bottom'], 10),
    left: parseInt(style['padding-left'], 10),
    right: parseInt(style['padding-right'], 10)
  };
}

exports.getPadding = getPadding;

function translateThumbs(elements, offsets) {
  elements.forEach(function (element, index) {
    return translate(element, offsets[index].x, offsets[index].y);
  });
}

exports.translateThumbs = translateThumbs;

function translate(element, x, y) {
  element.style.transform = "translate(" + x + "px, " + y + "px)";
}

exports.translate = translate; // adapted from https://github.com/alexreardon/raf-schd

exports.schd = function (fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  return wrapperFn;
};

function replaceAt(values, index, value) {
  var ret = values.slice(0);
  ret[index] = value;
  return ret;
}

exports.replaceAt = replaceAt;

function getTrackBackground(_a) {
  var values = _a.values,
      colors = _a.colors,
      min = _a.min,
      max = _a.max,
      _b = _a.direction,
      direction = _b === void 0 ? types_1.Direction.Right : _b;
  var progress = values.map(function (value) {
    return (value - min) / (max - min) * 100;
  });
  var middle = progress.reduce(function (acc, point, index) {
    return acc + ", " + colors[index] + " " + point + "%, " + colors[index + 1] + " " + point + "%";
  }, '');
  return "linear-gradient(" + direction + ", " + colors[0] + " 0%" + middle + ", " + colors[colors.length - 1] + " 100%)";
}

exports.getTrackBackground = getTrackBackground;

function voidFn() {}

exports.voidFn = voidFn;

function assertUnreachable(x) {
  throw new Error("Didn't expect to get here");
}

exports.assertUnreachable = assertUnreachable;